var _symbol, _use, _use2, _use3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTypeofwebPattern = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 128 22"
}, props), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.3 10.8 7.9 3.2-.6 1.7-9.6-4V9.9l9.6-4.1.6 1.7zM13 21.5h-2.2L18.4 0h2.1zm8.1-14 .6-1.7 9.6 4.1v1.8l-9.6 4-.6-1.7 7.9-3.2z"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  href: "#a"
})), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
  x: 48,
  href: "#a"
})), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
  x: 96,
  href: "#a"
})));

export default SvgTypeofwebPattern;